import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-book-2-line",
    title: "单行本全卷",
    desc: "从第1卷到完结卷，卷卷按序整理，主线完整无缺。",
  },
  {
    icon: "ri-magic-line",
    title: "全彩珍藏",
    desc: "初遇、告白、终章等名场面全彩重制，色彩细腻。",
  },
  {
    icon: "ri-gift-line",
    title: "番外收录",
    desc: "新婚篇、童年篇、情人节篇等番外单独归入分类。",
  },
  {
    icon: "ri-list-check-2",
    title: "目录清晰",
    desc: "按卷与话数分类，找齐整部作品更方便快捷。",
  },
];

export default function Story() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 md:px-6 lg:grid-cols-2">
        <div>
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">系列导读</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一部关于契约、真心与勇气的恋爱物语
          </h2>
          <p className="mt-5 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            《甜蜜惩罚》是一部以细腻情感与暧昧张力见长的恋爱漫画。故事从一场无法拒绝的契约开始，
            女主角在身份悬殊的关系中逐渐卸下防备，从试探、误会到真心相许，
            铺陈出一段既有甜蜜悸动、也不乏波折的浪漫旅程。
          </p>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            本站按单行本卷与话数整理整部作品的完整目录，无论是初次接触的新读者，
            还是想要回看某一名场面的老读者，都能在这里快速定位到想读的章节。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
          >
            了解网站理念
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {highlights.map((h) => (
            <div key={h.title} className="rounded-2xl bg-background-100 p-5 transition-colors hover:bg-background-200/70">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className={`${h.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{h.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{h.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}